module.exports = __webpack_public_path__ + "img/service_guide_step2.e928ba7.png";